export default {
    InlineTranslationMessageTranslated: {
        name: 'InlineTranslationMessageTranslated',
        cosmosOnlyData: (itemId: string, subject: string) => itemId,
    },

    InlineTranslationMessageUntranslated: {
        name: 'InlineTranslationMessageUntranslated',
        cosmosOnlyData: (itemId: string) => itemId,
    },
};
